import Collapse from './Collapse';
import * as Types from './Collapse.d';

export type CollapseProps = Types.CollapseProps;
export default Collapse;
